/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createSelector } from 'reselect';

const FREELANCE_INPUTS = [
  'terms',
  'id_number',
  'iban',
  'bic',
  'tax_country',
  'street1',
  'zip',
  'city',
  'country',
];

const COOLCOMPANY_INPUTS = [
  'tax_country',
  'coolcompany',
  'id_number',
  'clearing_number',
  'account_number',
  'street1',
  'zip',
  'city',
  'country',
];

const getIsCoolCompany = (state, props) => props.isCoolCompany;
const getFreelanceForm = state => state.freelanceForm;
const getConstants = state => state.bootstrap.constants;

export const makeRegisterFreelanceForm = () =>
  createSelector(
    [getIsCoolCompany, getFreelanceForm, getConstants],
    (isCoolCompany, freelanceForm, constants) => {
      const fieldsets = freelanceForm.fieldsets.map(({ legend, inputs }) => ({
        legend,
        inputs: inputs
          .map(
            input =>
              input.name === 'country'
                ? { ...input, options: constants.address_countries }
                : input
          )
          .map(
            input =>
              input.name === 'tax_country'
                ? { ...input, options: constants.tax_countries }
                : input
          ),
      }));

      if (isCoolCompany) {
        return {
          ...freelanceForm,
          fieldsets: fieldsets.map(({ legend, inputs }) => ({
            legend,
            inputs: inputs.filter(
              input => COOLCOMPANY_INPUTS.indexOf(input.name) !== -1
            ),
          })),
        };
      }

      return {
        ...freelanceForm,
        fieldsets: fieldsets.map(({ legend, inputs }) => ({
          legend,
          inputs: inputs.filter(
            input => FREELANCE_INPUTS.indexOf(input.name) !== -1
          ),
        })),
      };
    }
  );
